export default __webpack_public_path__ + "static/CL-3-4ff43eff9e68d3e1ac4fb21763028149.png";